/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { CreateSaleTypes, CreateSaleState } from './types';

const INITIAL_STATE: CreateSaleState = {
  create_sale: {
    sale: {
      venda: {
        cliente_id: 0,
        contato_cliente_id: 0,
        created_at: '',
        data_cancelamento: null,
        data_vencimento: '',
        formas_pagamento_id: '',
        from_site: 0,
        id: 0,
        motivo_cancelamento_id: null,
        observacao: '',
        parcelas: 0,
        recompra: 0,
        renovacao_automatica: 0,
        status_carrinho_id: 0,
        status_id: 0,
        tipo_venda_id: 0,
        updated_at: '',
        usuario_criacao_id: 0,
        usuario_modificacao_id: 0,
        valor_adicional: '',
        valor_base: '',
        valor_desconto_negociacao: '',
        valor_total: '',
        valor_variacao_forma_pagamento: '',
      },
    },
    vigencia_fim: '',
    vigencia_inicio: '',
    services_name: [],
    is_charged: false,
    return_code: null,
    display: '',
  },
  requestCreate: {
    loading: false,
    loaded: false,
    error: false,
  },
};
const reducer: Reducer<CreateSaleState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case CreateSaleTypes.GET_CREATE_SALE_REQUEST:
        draft.create_sale = INITIAL_STATE.create_sale;
        draft.requestCreate = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case CreateSaleTypes.GET_CREATE_SALE_SUCCESS:
        const response = result.data;

        if (response?.display === 'duplicate_sale') {
          window.location.href = '/contato';
        }

        draft.create_sale.vigencia_fim = result.data.vigencia_fim;
        draft.create_sale.vigencia_inicio = result.data.vigencia_inicio;
        draft.create_sale.sale = result.data.body;
        draft.create_sale.services_name = result.data.services_name;
        draft.create_sale.is_charged = response.body.is_charged;
        draft.create_sale.return_code = response.body.return_code;
        draft.create_sale.display = response?.display;
        draft.requestCreate = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case CreateSaleTypes.GET_CREATE_SALE_FAILURE:
        draft.requestCreate = {
          loading: false,
          loaded: false,
          error: true,
        };
        draft.create_sale = INITIAL_STATE.create_sale;
        break;
      default:
    }
  });
};
export default reducer;
